import type AggregationFilter from '../store/AggregationFilter';
import BedroomsFilter from '../store/BedroomsFilter';
import FlexibleArrivalDateFilter from '../store/FlexibleArrivalDateFilter';
import HouseSearchFilters from '../store/HouseSearchFilters';
import KeywordFilter from '../store/KeywordFilter';
import PriceFilter from '../store/PriceFilter';
import TravelPartyFilter from '../store/TravelPartyFilter';
import type { GTMOverviewFilterRemoveModelData } from '../../../gtm/models/GTMOverviewFilterRemoveModel';
import GTMOverviewFilterRemoveModel from '../../../gtm/models/GTMOverviewFilterRemoveModel';
import GTM from '../../../gtm/GTM';

export default class SelectedFiltersToFilterMapping {
    // eslint-disable-next-line max-lines-per-function
    public static map(): Map<string, CallableFunction> {
        const filters = HouseSearchFilters.getInstance();

        const trackFilterRemove = ({
            label,
            category
        }: Omit<GTMOverviewFilterRemoveModelData, 'location'>): void => {
            GTM.track(
                GTMOverviewFilterRemoveModel.parseToGTMData({
                    label,
                    category,
                    location: 'quickfilter'
                })
            );
        };

        return new Map([
            [
                'keyword',
                (): void => {
                    const filter = filters.get(KeywordFilter.NAME) as KeywordFilter;
                    filter.clear();
                }
            ],
            [
                'adults',
                (): void => {
                    const filter = filters.get(TravelPartyFilter.NAME) as TravelPartyFilter;
                    filter.adults = 0;
                }
            ],
            [
                'children',
                (): void => {
                    const filter = filters.get(TravelPartyFilter.NAME) as TravelPartyFilter;
                    filter.children = 0;
                }
            ],
            [
                'babies',
                (): void => {
                    const filter = filters.get(TravelPartyFilter.NAME) as TravelPartyFilter;
                    filter.babies = 0;
                }
            ],
            [
                'pets',
                (): void => {
                    const filter = filters.get(TravelPartyFilter.NAME) as TravelPartyFilter;
                    filter.pets = 0;
                }
            ],
            [
                'minPrice',
                (): void => {
                    const filter = filters.get(PriceFilter.NAME) as PriceFilter;
                    filter.min = 0;
                    trackFilterRemove({ label: PriceFilter.MIN_NAME, category: PriceFilter.NAME });
                }
            ],
            [
                'maxPrice',
                (): void => {
                    const filter = filters.get(PriceFilter.NAME) as PriceFilter;
                    filter.max = null;
                    trackFilterRemove({ label: PriceFilter.MAX_NAME, category: PriceFilter.NAME });
                }
            ],
            [
                'flexibleArrivalDate',
                (): void => {
                    const filter = filters.get(
                        FlexibleArrivalDateFilter.NAME
                    ) as FlexibleArrivalDateFilter;
                    filter.clear();
                }
            ],
            [
                'bedrooms',
                (): void => {
                    const filter = filters.get(BedroomsFilter.NAME) as BedroomsFilter;
                    const bedrooms = filter.parameters.bedrooms;

                    filter.clear();
                    trackFilterRemove({
                        label: bedrooms || '',
                        category: BedroomsFilter.NAME
                    });
                }
            ],
            [
                'aggregation',
                (name: string, value: string): void => {
                    const filter = filters.get(name) as AggregationFilter;
                    filter.remove(value);
                    trackFilterRemove({ label: value, category: name });
                }
            ]
        ]);
    }
}
